// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; // ⬅️ Agregado

const firebaseConfig = {
  apiKey: "AIzaSyAMhvown3hhR8z-BUpVzSNBXJglVO9gKgg",
  authDomain: "quimsa-sitio.firebaseapp.com",
  projectId: "quimsa-sitio",
  storageBucket: "quimsa-sitio.firebasestorage.app",
  messagingSenderId: "213479919987",
  appId: "1:213479919987:web:e4fa2a1ad037bd68023506"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// ⬇️ Agregá esta línea para obtener el auth
const auth = getAuth(app);

// ⬇️ Exportá auth para que lo uses en Socios.jsx
export { auth };
export default app;
